import React, {
	useCallback,
	useContext,
	useEffect,
	useRef,
	useState,
} from 'react';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import { calendrier } from '../../../utils/images';
import QuoteElementExpert from '../QuoteElementExpert/QuoteElementExpert';
import { ExpertContext } from '../../Contexts/contexts';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import { shouldFetchData, status } from '../../../data/fetchStatus';
import useToast from '../../Toasts/useToast';
import {
	ToastHeaders,
	ToastThemes,
	ToastMessages,
} from '../../Toasts/ToastOptions/toastOptions';
import Services from '../../Services/services';
import useAuth from '../../Contexts/useAuth';
import useCheckout from '../../Contexts/useCheckout';
import usePaymentPeriod from '../../Contexts/usePaymentPeriod';

function AcceptedRdvExpert() {
	const expertContext = useContext(ExpertContext);

	const [clients, setClients] = useState([]);
	const [clientsFetched, setClientsFetched] = useState(status.DEFAULT);

	const enqueueToast = useToast();
	const { checkAuth, validateRoleRoute } = useAuth();
	const checkout = useCheckout();
	const checkPaymentPeriod = usePaymentPeriod();
	const ref = useRef(true);

	const fetchClients = useCallback(async () => {
		if (
			expertContext?.clientExpertRelations?.length === 0 ||
			clientsFetched === status.FETCHED
		)
			return;

		setClientsFetched(status.FETCHED);

		try {
			let clientsIds = [];

			expertContext
				?.getClientExpertRelationsByStatus([2, 3, 4])
				.forEach((clientExpertRelation) => {
					clientsIds.push(clientExpertRelation.clientId);
				});

			const data = await Services.profileService.clientsByIDs(clientsIds, true);

			if (data.length === 0) return;

			setClients(data);
		} catch (error) {
			enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
				theme: ToastThemes.toastThemes.ERROR_OCCURED,
				header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
				duration: 3000,
			});
		}
	}, [expertContext, clientsFetched, enqueueToast]);

	useEffect(() => {
		if (checkAuth()) {
			if (validateRoleRoute('expert')) {
				if (checkout('/accepted-rdv')) {
					if (checkPaymentPeriod('/accepted-rdv')) {
						const firstRendering = ref.current;

						if (firstRendering) {
							ref.current = false;
							expertContext?.refreshClientExpertRelations();
							expertContext?.refreshAppointments();
						} else {
							if (shouldFetchData(clientsFetched)) fetchClients();
						}
					}
				}
			}
		}
	}, [
		clientsFetched,
		fetchClients,
		checkAuth,
		validateRoleRoute,
		checkout,
		checkPaymentPeriod,
		expertContext,
	]);

	// Fonction qui permet d'afficher les rdv acceptes
	function getAllRdvElements() {
		const rdvElementsItems = [];

		expertContext
			?.getClientExpertRelationsByStatus([2, 3, 4])
			.filter((cer) => cer.expertSigned !== 1)
			.forEach((clientExpertRelation) => {
				rdvElementsItems.push(
					<QuoteElementExpert
						clientExpertRelation={clientExpertRelation}
						client={clients?.find((client) => {
							return client?.userId === clientExpertRelation?.client?.userId;
						})}
						appointment={getAppointment(clientExpertRelation.id)}
						key={clientExpertRelation.id}
					/>
				);
			});

		return rdvElementsItems;
	}

	function getAppointment(clientExpertRelationshipId) {
		const appointment = expertContext?.appointments.filter(
			(item) => item?.clientExpertRelationshipId === clientExpertRelationshipId
		);

		return appointment.length > 0 ? appointment[0] : undefined;
	}

	return (
		<>
			<HeaderMinimal />
			<div className="ts-container accepted-rdv">
				<SideMenu />
				<div className="ts-container-main">
					<div className="ts-details-container">
						<div className="ts-details">
							<div className="ts-title">Rendez-vous accepté</div>
							<div className="ts-resume">
								Félicitations, les rendez-vous énumérés ci-dessous sont
								désormais confirmés. Vous pouvez à présent accéder aux
								coordonnées du client que vous avez accepté, afin de prendre
								contact avant la tenue du rendez-vous. <br />
								Pour visualiser les coordonnées, veuillez cliquer sur l'icône en
								forme d'œil située à droite.
							</div>
						</div>
						<div className="ts-number">
							<div className="ts-number-container">
								<div className="ts-number-title">Rendez-vous accepté</div>
								<div className="ts-number-current">
									{
										expertContext
											?.getClientExpertRelationsByStatus([2, 3, 4])
											.filter((cer) => cer.expertSigned !== 1).length
									}
								</div>
							</div>
							<img className="ts-icon" src={calendrier} alt="devis icone"></img>
							<div className="purple-rod"></div>
						</div>
					</div>
					{expertContext
						?.getClientExpertRelationsByStatus([2, 3, 4])
						.filter((cer) => cer.expertSigned !== 1).length > 0 ? (
						<div className="rdv-container">
							<div className="rdv-elements-container">
								{getAllRdvElements()}
							</div>
						</div>
					) : (
						<div></div>
					)}
				</div>
			</div>
		</>
	);
}

export default AcceptedRdvExpert;
